import React, { useState, useEffect, useContext, useCallback } from "react";
import api from "../services/api";
import ToastContext from "../contexts/ToastContext";
import PageHeader from "../components/PageHeader";
import Card from "../components/Card";
import { FaPlus, FaTrash } from "react-icons/fa";
import ConfirmationModal from "../components/ConfirmationModal";

const GerenciarCargos = () => {
  const [cargos, setCargos] = useState([]);
  const [nomeCargo, setNomeCargo] = useState("");
  const [modalState, setModalState] = useState({
    isOpen: false,
    cargoId: null,
  });
  const { addToast } = useContext(ToastContext);

  const fetchCargos = useCallback(async () => {
    try {
      const { data } = await api.get("/cargos");
      setCargos(data);
    } catch (error) {
      addToast("Erro ao buscar cargos.", "error");
    }
  }, [addToast]);

  useEffect(() => {
    fetchCargos();
  }, [fetchCargos]);

  const handleAddCargo = async (e) => {
    e.preventDefault();
    if (!nomeCargo.trim()) {
      addToast("O nome do cargo não pode ser vazio.", "error");
      return;
    }
    try {
      await api.post("/cargos", { nome_cargo: nomeCargo });
      addToast("Cargo adicionado com sucesso!", "success");
      setNomeCargo("");
      fetchCargos();
    } catch (error) {
      addToast(
        error.response?.data?.message || "Erro ao adicionar cargo.",
        "error"
      );
    }
  };

  const handleDeleteCargo = (id) => {
    setModalState({ isOpen: true, cargoId: id });
  };

  const confirmDeleteCargo = async () => {
    try {
      await api.delete(`/cargos/${modalState.cargoId}`);
      addToast("Cargo excluído com sucesso!", "success");
      fetchCargos();
    } catch (error) {
      addToast("Erro ao excluir cargo.", "error");
    } finally {
      setModalState({ isOpen: false, cargoId: null });
    }
  };

  return (
    <>
      <ConfirmationModal
        isOpen={modalState.isOpen}
        onClose={() => setModalState({ isOpen: false, cargoId: null })}
        onConfirm={confirmDeleteCargo}
        title="Confirmar Exclusão"
        message="Tem certeza que deseja excluir este cargo?"
      />
      <PageHeader title="Gerenciar Cargos Globais" />
      <Card>
        <div className="form-shell">
          <form onSubmit={handleAddCargo}>
            <div className="form-group">
              <label htmlFor="nome_cargo">Nome do Cargo</label>
              <input
                id="nome_cargo"
                value={nomeCargo}
                onChange={(e) => setNomeCargo(e.target.value)}
                placeholder="Digite o nome do novo cargo"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn-modern">
                <FaPlus />
                <span>Adicionar Cargo</span>
              </button>
            </div>
          </form>
        </div>

        <table>
          <thead>
            <tr>
              <th>Nome do Cargo</th>
              <th className="column-actions">Ações</th>
            </tr>
          </thead>
          <tbody>
            {cargos.length > 0 ? (
              cargos.map((cargo) => (
                <tr key={cargo.id}>
                  <td data-label="Cargo">{cargo.nome_cargo}</td>
                  <td
                    data-label="Ações"
                    className="actions-cell column-actions"
                  >
                    <button
                      onClick={() => handleDeleteCargo(cargo.id)}
                      className="action-btn delete"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} className="muted-text">
                  Nenhum cargo cadastrado até o momento.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Card>
    </>
  );
};

export default GerenciarCargos;
